import { ChangeEvent, useState, useEffect } from "react";
import { AddIconGreen, CharityPreviewIcon } from "../../../public/assets";

import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import { HorizontalLine, ButtonContainer } from "./Adhoc.styles";
import { CreatePaymentLink } from "../../graphql/mutations/paymentlink";
import { useNavigate } from "react-router-dom";
import {
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_BY_ORGANIZATION_ID,
  GET_PRODUCT,
  SEARCH_PRODUCT,
} from "../../graphql/queries/paymentlink";
import { useQuery, useMutation } from "@apollo/client";
import { getData } from "../../utils/localStorage";
import { environment } from "../../env";
import { useDispatch, useSelector } from "react-redux";
import { addSelectedProduct } from "../../store/products/productSlice";
import { debounce } from "../../utils/debounce";
import { LoadingSpinner } from "../AddUserPage/AddUser";
import Button from "../../components/Button/Button";

interface Charity {
  id: string;
  image: string;
  name: string;
  price: number;
  quantity: number;
  from: number;
  to: number;
}

const paymentCardData = [
  {
    id: 1,
    image: "/assets/svg/CharityPreviewIcon.svg",
    title: "Doe’s Charity",
    subtitle: "This is for the less privileged",
  },
];
interface ShowCharityData {
  showCharity?: any;
  setShowCharity?: any;
}
interface FormData {
  redirectAfterPayment: string;
  successMessage: string;
  useYourCustomLink: string;
  url: string;
}
interface LinkOptionsProp {
  label: string;
  value: string;
  isTrue: boolean;
}

const type = getData("type");
const organizationId = getData("organizationId");
const paymentType = getData("paymentType");

const AdhocPaymentLink: React.FC<{
  formData?: FormData;
  options?: any;
  LinkOptions?: LinkOptionsProp[];
}> = ({ formData, options, LinkOptions }) => {
  const dispatch = useDispatch();
  const { loading, error, data } = useQuery(
    GET_ALL_PRODUCTS_BY_ORGANIZATION_ID,
    {
      variables: {
        ...environment.paymentLinkService,
        payload: {
          limit: 10,
          page: 1,
        },
      },
    }
  );
  const [createPaymentLink, { loading: paymentLoading }] = useMutation(
    CreatePaymentLink,
    {
      variables: { ...environment.paymentLinkService },
    }
  );
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProductIds, setSelectedProductIds] = useState<
    { id: string }[]
  >([]);
  const {
    loading: loadingSearchProduct,
    error: errorSearchProduct,
    data: searchProductData,
  } = useQuery(SEARCH_PRODUCT, {
    variables: {
      ...environment.paymentLinkService,
      query: searchQuery,
      // organizationId: organizationId,
    },
  });

  const [charity, setCharity] = useState<Charity[]>([]);
  const [checkedValue, setCheckedValue] = useState<string[]>([]);
  const [minimumPayment, setMinimumPayment] = useState<number>(0);
  const [showSelectPop, setShowSelectPop] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [showPreviewAddNewGreen, setShowPreviewAddNewGreen] = useState(true);
  const [showPaymentInput, setShowPaymentInput] = useState(true);

  const selector = useSelector((state: any) => state.charitys);

  useEffect(() => {
    if (!loading && data) {
      const { getAllProductsByOrganizationId } = data;
      if (getAllProductsByOrganizationId) {
        setCharity(getAllProductsByOrganizationId.data);
      }
    }
  }, [loading, data]);

  const handleCharityCard = () => {
    setShowSelectPop(!showSelectPop);
  };

  const debouncedSearch = debounce((value: string) => {
    setSearchQuery(value);
  }, 300);

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    debouncedSearch(value);
  };

  const handleSelectedProduct = (charity: any) => {
    const { id, name, description, organizationId, price } = charity;
    const selectedProduct: any = {
      id,
      name,
      description,
      organizationId,
      price,
    };
    dispatch(addSelectedProduct(selectedProduct));
  };

  const handleAddNewCharityClick = () => {
    setShowPaymentInput(true);
    setShowSelectPop(false);
    setShowPreviewAddNewGreen(false);
  };

  // const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
  //   const { value, checked } = e.target;

  //   if (checked) {
  //     setCheckedValue([...checkedValue, value]);
  //     if (value === "customerAddress") {
  //       setShowCharity(value);
  //     }
  //   } else {
  //     setCheckedValue(checkedValue.filter((val) => val !== value));
  //     if (value === "customerAddress") {
  //       setShowCharity("");
  //     }
  //   }
  // };
  const handleCreatePaymentLink = async () => {
    try {
      const options: any = {};
      LinkOptions!.forEach((option) => {
        if (option.isTrue) {
          options[option.value] = true;
        } else {
          options[option.value] = false;
        }
      });
      const response = await createPaymentLink({
        variables: {
          input: {
            type: type || "adhocPayment",
            // organizationId: organizationId,
            products: selectedProductIds,
            options: options,
            advanceOption: {
              redirectAfterPayment: formData!.redirectAfterPayment,
              successMessage: formData!.successMessage,
              useYourCustomLink: formData!.useYourCustomLink,
            },
          },
        },
      });
      const id = response.data?.createPaymentLink?.id;
      if (id) {
        navigate("/dashboard/sucess/" + id);
      }

      // const shortCode = response?.data?.createPaymentLink?.shortcode;
      //
      // if (response && response.data) {
      //   navigate(`/dashboard/success/${shortCode}`);
      // }
    } catch (error) {}
  };
  // const isDisabled = options.length === 0 || paymentLoading;
  const isDisabled = paymentLoading;
  return (
    <ButtonContainer>
      <Button
        green
        title={
          paymentLoading ? (
            <LoadingSpinner small $auto />
          ) : (
            "Create Payment Link"
          )
        }
        padding={"10px 45px"}
        onClick={handleCreatePaymentLink}
        disabled={isDisabled}
        id={""}
        border="10px"
      />
    </ButtonContainer>
  );
};

export default AdhocPaymentLink;
